module.exports = __webpack_public_path__ + "img/check-icon.9bb522d3.svg";